import { logWrapper } from '../../utils';
import CryptoJS from 'crypto-js';
import swal from 'sweetalert2';

export default {
  userController: [
    'runtimeConstant',
    '$q',
    '$scope',
    '$http',
    '$rootScope',
    'authService',
    '$filter',
    'webApiSettings',
    '$uibModal',
    '$uibModalInstance',
    'isChangeOnLogin',
    'currentPass',
    function (
      runtimeConstant,
      $q,
      $scope,
      $http,
      $rootScope,
      authService,
      $filter,
      webApiSettings,
      uibModal,
      $uibModalInstance,
      isChangeOnLogin,
      currentPass
    ) {
      'use strict';

      function handleError(err, status) {
        //falhou
        if (status === 404) {
          var error = {
            error: $filter('translate')('SERVER OFFLINE'),
            // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
            // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
          };

          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
            // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
          };

          return ex;
        }

        var ex1 = {
          error: $filter('translate')('UNEXPECTED ERROR'),
          // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
          error_description:
            err !== null && err !== ''
              ? err.toString()
              : $filter('translate')('UNEXPECTED MESSAGE'),
          // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
        };

        return ex1;
      }

      function cancel() {
        $scope.messageTitle = $scope.isChangeOnLogin
          ? $filter('translate')('CONFIRM CANCEL CHANGE PASS LOGOUT')
          : $filter('translate')('CONFIRM CANCEL CHANGE PASS');

        $scope.messageForward = $filter('translate')('YES');
        $scope.messageCancel = $filter('translate')('NO');

        $rootScope.cancelChangePasswordModal = uibModal.open({
          scope: $scope,
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modal/questionModal/questionModal.html',
          controller: 'cancelPasswordModalController',
          size: 'small',
          windowClass: 'modal-remove',
          resolve: {
            changePassModal: () => $scope.changePassModal,
          },
        });
      }

      function save() {
        var criptoPass = $scope.isChangeOnLogin
          ? $scope.currentPass
          : CryptoJS.MD5($scope.currentPass).toString();
        if (authService.user.pass !== criptoPass) {
          swal.fire({
            title: $filter('translate')('CURRENT PASSWORD DOES NOT MATCH'),
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: $filter('translate')('OK'),
          });
          return;
        }
        if ($scope.newPass !== $scope.confirmPass) {
          swal.fire({
            title: $filter('translate')('PASSWORDS DOES NOT MATCH'),
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: $filter('translate')('OK'),
          });
          return;
        }
        swal.fire({
          title: 'Aguarde',
          text: 'Alterando a senha',
          icon: 'info',
          showConfirmButton: false,
        });

        var deferred = $q.defer();

        var changePass = {};
        changePass[$filter('translate')('USER')] =
          authService.user.id.toString();
        changePass[$filter('translate')('CURRENTPASSWORD')] = criptoPass;
        changePass[$filter('translate')('NEWPASSWORD')] = CryptoJS.MD5(
          $scope.newPass
        ).toString();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'users/changePass/',
            changePass
          )
          .then(
            function () {
              deferred.resolve(true);

              authService.user.pass = CryptoJS.MD5($scope.newPass).toString();
              authService.user.changePass = false;
              swal.close();
              $uibModalInstance.close(true);
            },
            function (err, status, headers, config) {
              var error = $scope.handleError(err, status, headers, config);

              deferred.reject(error);
              swal.close();
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          $scope.isChangeOnLogin = isChangeOnLogin;
          $scope.currentPass = currentPass;
          $scope.newPass = '';
          $scope.confirmPass = '';
          $scope.currentPassFocus = isChangeOnLogin === false;
          $scope.newPassFocus = isChangeOnLogin;

          $scope.handleError = logWrapper(
            handleError,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancel = logWrapper(
            cancel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.save = logWrapper(
            save,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
